<div class="line-chart-container ion-text-center">
    <canvas baseChart #baseLineChart chartType="line" [datasets]="lineChartDatas" [labels]="lineChartLabels" [options]="lineChartOptions" [legend]="isShowLegend" [plugins]="lineChartPlugins"></canvas>
</div>
